// extracted by css-extract-rspack-plugin
export default {"cls1":"TransactionalPricingModal-cls1_9FC","cls2":"TransactionalPricingModal-cls2_Tol TransactionalPricingModal-cls1_9FC"};